import { useDataChange, useDataValue } from 'Simple/Data.js'
import isEqual from 'lodash/isEqual.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'event_action',
    path: 'actions',
    viewPath: props.viewPath,
  })

  let actions = useDataValue({
    context: 'event_action',
    path: 'actions',
    viewPath: props.viewPath,
  })

  return function onChange(rvalue) {
    let value = Array.isArray(rvalue) ? rvalue : [rvalue]
    if (!isEqual(actions, value)) {
      change(value)
    }
  }
}
